var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTikTokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.548,
    height: 14.663,
    viewBox: "0 0 12.548 14.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "TikTok-icon",
    d: "M8.942,0h-2.1L6.82,10.242a2.33,2.33,0,0,1-2.365,2.246,2.274,2.274,0,1,1,0-4.548,2.285,2.285,0,0,1,.275.028v-2.2c-.091-.006-.182-.014-.275-.014A4.455,4.455,0,1,0,8.91,10.213V4.186a3.914,3.914,0,0,0,3.275,1.77q.181,0,.361-.018h0V3.5A3.912,3.912,0,0,1,8.942,0",
    transform: "translate(0 -0.005)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTokIcon);
export default __webpack_public_path__ + "static/media/TikTok-icon.8135502eab2d8105b6739be4ac1361a8.svg";
export { ForwardRef as ReactComponent };